<script>
import {checkboxInputMixin} from "../../../helpers/checkboxInput.js"

export default {
    mixins: [checkboxInputMixin],
    props: {
        processHistory: Object
    },
    data() {
        return {
            jobs: {},
            showModal: false,
            action: null,
        }
    },
    created() {
        this.processHistory.data.map(job => {
            this.$set(this.jobs, job.id, {
                checked: false
            })
        });
    },
    computed: {
        hasChecked() {
            for (let key in this.jobs) {
                if (this.jobs[key].checked) {
                    return true;
                }
            }
            return false;
        },
        selectedFields() {
            return Object.keys(this.jobs).filter(index => {
                return this.jobs[index].checked;
            });
        },
        modalBody() {
            return `Are you sure want to bulk ${this.action} for selected Jobs?`;
        }
    },
    methods: {
        confirmAction(action) {
            this.showModal = true;
            this.action = action;
            console.log(action);
        },
        doAction() {
            let link;
            if (this.action === 'cancel') {
                link = this.route('mass-cancel-processing');
            } else if (this.action === 'restart') {
                link = this.route('mass-restart-processing');
            } else if (this.action === 'delete') {
                link = this.route('mass-delete-processing');
            }
            return axios.post(link, {jobs: this.selectedFields})
                .then((response) => {
                    if (response.status) {
                        this.showModal = false;
                        location.reload();
                    }
                });

        },
        closeModal() {
            this.showModal = false;
            this.action = null;
        }
    }
}
</script>
